<script setup lang="ts">
import zhCn from "element-plus/es/locale/lang/zh-cn";
</script>

<template>
  <!-- 中文语言包在这里统一提供：Element Plus 的内置文案（分页、日期、上传提示）都走它。 -->
  <el-config-provider :locale="zhCn">
    <router-view />
  </el-config-provider>
</template>
